export default "/assets/images/clean-like-boss.77b1f33b2e4b386c.png";